import PropTypes from 'prop-types';
import React, { Suspense, lazy, useMemo } from 'react';
import { catalogue_structure } from '../../catalogues';
import Grid from '@mui/material/Unstable_Grid2';
import ErrorBoundary from './ErrorBoundary';
import { CircularProgress } from '@mui/material';
import { lazyRetry } from '../../helpers/functions/lazy_loading';

function MemoizedLazyComponent({ name, content, lazy_loading, component_props }) {
	const LazyComponent = useMemo(() => {
		return lazy(() => lazyRetry(async () => {
			const [moduleExports] = await Promise.all([import('../' + content), new Promise((resolve) => setTimeout(resolve, lazy_loading))]);
			return moduleExports;
		}, name));
	}, [component_props, name]);

	return (
		<Suspense fallback={<CircularProgress size={20} />}>
			<LazyComponent {...component_props} />
		</Suspense>
	);
}

export const CatalogueGrid = ({ catalogue: { name, id, widgets = [], ...props } = { widgets: [] } }) => {
	return (
		<Grid container spacing={2} {...props}  id={id}>
			{widgets.map((item, index) => (
				<Grid key={index} {...item.breakpoints} {...item.sx} {...item.grid_props}>
					{typeof item.content === 'string' ? (
						<ErrorBoundary>
							<MemoizedLazyComponent name={name} {...item} />
						</ErrorBoundary>
					) : (
						<CatalogueGrid catalogue={item.content} />
					)}
				</Grid>
			))}
		</Grid>
	);
};

CatalogueGrid.propTypes = {
	catalogue: PropTypes.shape(catalogue_structure),
	spacing: PropTypes.number,
};

export default CatalogueGrid;
